import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { Acreditacion } from "./pages/Acreditacion";
import { Pilares } from "./pages/Pilares";
import { Recursos } from "./pages/Recursos";
import { Noticias } from "./pages/Noticias";
import { Contacto } from "./pages/Contacto";
import AdminPanel from "./pages/AdminPanel";
import { NoticiaDetalle } from "./pages/NoticiaDetalle";
import { Toaster } from "./components/ui/toaster";
import { ScrollToTop } from "./components/ScrollToTop";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/acreditacion" element={<Acreditacion />} />
            <Route path="/pilares" element={<Pilares />} />
            <Route path="/recursos" element={<Recursos />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/noticias/:id" element={<NoticiaDetalle />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
        {/* WhatsApp Floating Button */}
        <a
          href="https://wa.me/5213173851203"
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg p-3 flex items-center justify-center"
          style={{ boxShadow: '0 4px 16px rgba(0,0,0,0.15)' }}
          aria-label="Enviar WhatsApp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.149-.67.15-.197.297-.767.967-.94 1.164-.173.198-.347.223-.644.075-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.372-.025-.521-.075-.149-.669-1.611-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.372-.01-.571-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.076 4.348.709.306 1.262.489 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 5.617h-.001a8.77 8.77 0 0 1-4.473-1.226l-.321-.191-3.326.849.889-3.244-.209-.332a8.815 8.815 0 0 1-1.352-4.626c.001-4.85 3.953-8.797 8.803-8.797 2.349 0 4.555.916 6.219 2.577a8.706 8.706 0 0 1 2.58 6.211c-.003 4.85-3.953 8.797-8.803 8.797m7.158-15.955A10.408 10.408 0 0 0 12.05 2C6.495 2 2.052 6.438 2.05 11.988c0 1.873.491 3.699 1.425 5.304L2 22l5.392-1.404a10.443 10.443 0 0 0 4.634 1.111h.005c5.554 0 10.001-4.438 10.003-9.988a9.96 9.96 0 0 0-2.934-7.022"/></svg>
        </a>
      </BrowserRouter>
    </div>
  );
}

export default App;
